
const digest = '9d73527626f8a8a1042de989c031b5cbe703d01619b535abb35afcabe77b8abe';
const css = `._lightboxjs_5wij0_1 {
  margin: 0;
  padding: 0;
}

._lightboxjs_5wij0_1 * {
  box-sizing: border-box;
}

/* .lightboxjs img,
.lightboxjs svg,
.lightboxjs video {
  display: block;
  vertical-align: middle;
  height: auto;
  max-width: 100%;
} */

._slideshowBtn_5wij0_37 {
  padding-bottom: 2px;
}

._closeIcon_5wij0_45:hover,
._closeIcon_5wij0_45:focus,
._iconsHeader_5wij0_49 svg:hover,
._iconsHeader_5wij0_49 svg:focus,
._prev1_5wij0_53 span:hover,
._next1_5wij0_55:hover,
._icon_5wij0_49:hover {
  text-decoration: none;
  cursor: pointer;
  /* color: rgb(230, 230, 230); */
}

._prevIcon_5wij0_69:hover,
._nextIcon_5wij0_71:hover {
  background-color: rgba(0, 0, 0, 0.8);
  color: rgb(230, 230, 230);
}

._show_5wij0_81 {
  display: flex;
}

._displayHidden_5wij0_89 {
  display: none;
}

._thumbnail_5wij0_97 {
  opacity: 1;
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
}

._next1_5wij0_55 {
  right: 1%;
  padding-left: 2vw;
  padding-right: 3vw;
}

._prev1_5wij0_53 {
  left: 2%;
  padding-right: 2vw;
}

._thumbnails_5wij0_133 {
  transition: border 0.3s;
}

._thumbnail_5wij0_97 {
  display: inline;
}

._thumbnailsWithCaption_5wij0_149 {
  width: 90%;
}

._thumbnailsOuterContainer_5wij0_157 {
  position: absolute;
  bottom: 4%;
  height: 5vh;
  width: 100vw;
  z-index: 10000000;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

._navigationDots_5wij0_181 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

/* Mobile screens */
@media screen and (min-width: 20em) {
  ._imageSlide_5wij0_197 {
    height: 67vw;
    width: 60%;
  }

  ._thumbnailsOuterContainer_5wij0_157 {
    position: absolute;
    bottom: 7%;
    width: 100vw;
    /* width: 100%; */
  }

  ._thumbnailsAndCaption_5wij0_221 {
    height: 23vh;
    bottom: 2%;

  }

  ._hideControlsBar_5wij0_233 ._slideshowImg_5wij0_233 {
    /* height: 100vh; */
  }

  ._rotateImgInnerContainer_5wij0_241 {
    top: 8%;
  }

  ._hideControlsBar_5wij0_233 ._slideshowInnerContainer_5wij0_249 {
    top: 0;
  }

  ._thumbnail_5wij0_97 {
    width: 80px;
    max-width: 80px;
    height: 7vh;
  }

  ._videoThumbnailsOuterContainer_5wij0_269 {
    bottom: 2%;
  }

  ._imgTitleContainer_5wij0_277 {
    padding-bottom: 16px;
    width: 100vw;
    margin-top: 0;
    margin-bottom: 0;
  }

  ._thumbnails_5wij0_133 {
    margin-left: auto;
    margin-right: auto;
  }

  ._next1_5wij0_55 {
    right: 0.9%;
  }

  ._prev1_5wij0_53 {
    left: 1.5%;
  }
}

._thumbnail_5wij0_97 {
  height: 5vh;
  border-radius: 6px;
  margin-right: 7px;
  object-fit: cover;
}



._thumbnailsOuterContainerMetadata_5wij0_337 {
  width: 78vw;
}

._videoThumbnailsOuterContainer_5wij0_269 {
  bottom: 5%;
}

._thumbnailsAndCaption_5wij0_221 {
  height: 19vh;
}

._htmlVideoOuterContainer_5wij0_361 video {
  height: 100%;
  max-height: 70vh;
  width: 100%;
}

._caption_5wij0_373 {
  position: absolute;
  bottom: 14%;
  width: 100vw;
  z-index: 10000000;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
}

._galleryImg_5wij0_393 {
  cursor: pointer;
  margin: 0.2em;
}

._modalContainer_5wij0_403 {
  width: 100vw;
  /* height: 100%;
  max-height: 100%; */
  direction: ltr;
  overflow: hidden;
  touch-action: none;
  padding: 0;
  overflow-y: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
}

._slideshowAnimContainer_5wij0_441 {
  /* height: 100%;
  max-height: 100%; */
  direction: ltr;
  overflow: hidden;
  touch-action: none;
  padding: 0;
  overflow-y: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: fixed; */
  top: 0;
  left: 0;
  z-index: 1000000;
}

._fullScreenContainer_5wij0_477 img {
  height: 100vh;
  max-width: 100%;
  /* max-height: 100vh; */
}

._imageInnerContainer_5wij0_489 img {
  height: 80vh;
  max-width: 100%;
  max-height: 100%;
}

._imageInnerContainer_5wij0_489 {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 0;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  z-index: 1000000;
}

._magnifyWrapper_5wij0_527 {
  margin-bottom: 3em;
  margin-left: auto;
  margin-right: auto;
}

._slideshowInnerContainer_5wij0_249 {
  position: fixed; 
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: top 0.2s ease-in-out 0s;
  top: 12%;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  z-index: 1000000;
}

._slideshowInnerVideoContainer_5wij0_567 {
  top: 6%;
}

._slideshowInnerContainerThumbnails_5wij0_575 {
  top: 12%;
}

._hideControlsBar_5wij0_233  {
  top: 0;
}

._fullScreenContainer_5wij0_477 {
  top: 0;
}

._lightboxContainer_5wij0_599 {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

._next1_5wij0_55,
._prev1_5wij0_53 {
  top: calc(50% - 20px);
  position: absolute;
  display: flex;
  transition: all 0.2s;
  justify-content: center;
  align-items: center;
  padding-bottom: 2vh;
  padding-top: 2vh;
  user-select: none;
  cursor: pointer;
  font-weight: bold;
  border-radius: 30px;
  width: 40px;
  height: 40px;
  font-size: 18px;
  z-index: 10000000;
}



._next1_5wij0_55:hover,
._prev1_5wij0_53:hover {
  color: rgb(230, 230, 230);
}

._slideshowAnimImg_5wij0_671 {
  position: absolute;
  max-width: 100vw;
}

._controls_5wij0_681 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

._iconsHeader_5wij0_49 {
  color: white;
  position: absolute;
  display: flex;
  flex-direction: row;
  /* align-items: center;
    justify-content: center; */
  cursor: pointer;
  top: 10px;
  right: 45px;
  z-index: 999999999;
  /* padding: 0.14vw; */
}

._ytVideo_5wij0_721 {
  aspect-ratio: 16 / 9;
  height: 65vh;
  width: 100%;
}

._videoOuterContainer_5wij0_733 {
  width: 65%;
  margin-left: auto;
  margin-right: auto;
  height: 60vh;
  max-height: 65vh;
}

._htmlVideoOuterContainer_5wij0_361 {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

._customVideoContainer_5wij0_761, ._customEmbedContainer_5wij0_761 {
  margin-left: auto;
  margin-right: auto;
}

._videoIconsHeader_5wij0_771 {
  position: fixed;
  top: 4%;
  right: 3%;
}

._lightbox_5wij0_1 ._iconsHeader_5wij0_49 svg {
  transition: 0.3s all;
}

._iconsHeader_5wij0_49 svg:active {
  transform: scale(0.97);
}

._imgTitle_5wij0_277 {
  text-align: center;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

._iconsHeader_5wij0_49 svg {
  margin-left: 0.6em;
  padding: 0.2em;
  transition: all 0.1s;
  /* width: 32px;  */
  /* font-size: 18px; */
  line-height: 16px;
  vertical-align: baseline;
}

._icon_5wij0_49 {
  /* width: 32px;  */
}

@media screen and (min-width: 6em) {
  ._iconsHeader_5wij0_49 {
    top: 3%;
  }

  ._slideshowAnimContainer_5wij0_441 {
    width: 100vw;
  }

  ._iconsHeader_5wij0_49 svg {
    /* width: 34px;  */
    padding-right: 0.3em;
  }

  ._lightboxjs_5wij0_1 img {
    cursor: pointer;
  }

  ._thumbnail_5wij0_97 {
    height: 9vh;
    /* width: 22vw; */
  }

  ._next1_5wij0_55 {
    top: calc(48% - 20px);
  }

  ._prev1_5wij0_53 {
    top: calc(48% - 20px);

  }


}

@media screen and (min-width: 39em) {
  ._slideshowAnimContainer_5wij0_441 {
    width: 100vw;
  }

  ._slideshowInnerContainer_5wij0_249 {
    /* width: 100vw;
    height: 95vh;
    position: absolute; */
  }

  ._imgTitleContainer_5wij0_277 {
    padding-bottom: 0px;
  }
  

  ._next1_5wij0_55 {
    right: 0.7%;
  }

  /* .thumbnailsOuterContainer {
    bottom: 10%;
  } */

  /* .hideControlsBar .slideshow_img {
    height: 70vh;

  }

  .hideControlsBar {
    top: 10%;
  } */

  ._fullScreenContainer_5wij0_477 {
    width: 100vw;
    /* height: 100vh; */
  }

  ._fullScreenContainer_5wij0_477 img {
    height: 100vh;
  }

  ._thumbnails_5wij0_133 {
    margin-top: 0.6em;
  }

  ._thumbnail_5wij0_97 {
    /* height: 8vh; */
    width: 80px;
    max-width: 80px;
  }

  ._iconsHeader_5wij0_49 svg {
    /* width: 32px; 
      font-size: 32px; */
  }

  ._prev1_5wij0_53 {
    left: 2.7%;
    padding-right: 2vw;
  }
}

/* Desktop screens */
@media screen and (min-width: 42em) {
  ._imageSlide_5wij0_197 {
    height: 70vh;
    width: 80vw;
  }

  ._innerContainerWithTopCaption_5wij0_1051 {
    top: 8%;
  }

  ._slideshowImgFullscreen_5wij0_1059 {
    display: grid;
    width: 92vw;
    place-items: start;
    margin-left: auto;
    margin-right: auto;
    scrollbar-gutter: stable both-edges;
  }

  ._thumbnailsAndCaption_5wij0_221 {
    bottom: 0%;
  }
  
  ._rotateImgInnerContainer_5wij0_241 {
    top: 2%;
  }

  ._slideshowInnerContainer_5wij0_249 img {
    margin-top: 0vh;
    /* width: 70vw; */
  }

  ._fullScreenContainer_5wij0_477 img {
    width: 80vw;
  }

  ._slideshowInnerContainerFullScreen_5wij0_1111 {
    top: 0%;
  }

  ._fullScreenLightboxImg_5wij0_1119 {
    margin-left: auto;
    margin-right: auto;
    height: 100vh;
  }

  ._slideshowInnerContainerImgMetadata_5wij0_1131 {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  ._slideshowInnerContainerFullScreen_5wij0_1111 {
    height: 100vh;
    width: 100vw;
    position: absolute;
  }

  ._slideshowInnerContainerFullScreen_5wij0_1111 img {
    object-fit: contain;
  }

  ._thumbnails_5wij0_133 {
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin-top: 1.1em;
  }

  ._thumbnails_5wij0_133::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  ._opacity-fade_5wij0_1185 {
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    opacity: 1;
  }

  ._thumbnailsOuterContainer_5wij0_157 {
    margin-top: 0.1em;
    padding-top: 0.3em;
    height: 5vh;
    bottom: 11%;
  }

  ._thumbnailsAndCaption_5wij0_221 {
    bottom: 0%;
  }

  ._thumbnail_5wij0_97,
  ._imageSliderThumbnails_5wij0_1221 img {
    height: 10vh;
    /* width: 7em; */
  }

  ._slideshowAnimContainer_5wij0_441 {
    width: 100vw;
  }

  /* .slideshowInnerContainer {
    width: 100vw;
    height: 95vh;
  } */

  ._hideControlsBar_5wij0_233 {
    /* height: 100vh; */
  }

  ._fullScreenContainer_5wij0_477 {
    width: 100vw;
    /* height: 100vh; */
  }

  ._iconsHeader_5wij0_49 svg {
    /* width: 37px;
      font-size: 34px; */
  }

  ._prev1_5wij0_53 {
    left: 2%;
    padding-right: 2vw;
  }

  ._next1_5wij0_55 {
    right: 0.4%;
  }

  
  ._slideshowImgMetadata_5wij0_1297 {
    width: 78vw;
  }

  ._prev1Metadata_5wij0_1305 {
    left: 1%;
  }

  ._navigationDots_5wij0_181 {
    gap: 8px;
  }

 
}

@media screen and (min-width: 53em) {
  
  ._slideshowImg_5wij0_233 {
    display: grid;
    width: 100vw;
    height: 70vh;
    place-items: start;
    /* margin-top: 7vh; */
  }

  ._slideshowImgWithCaption_5wij0_1347 {
    height: 68vh;
  }

  ._hideControlsBar_5wij0_233 ._slideshowImg_5wij0_233, ._hideControlsBarAndCaption_5wij0_1355 ._slideshowImg_5wij0_233  {
    padding-top: 12vh;
  }

  ._fullScreenContainer_5wij0_477 ._slideshowImg_5wij0_233 {
    padding-top: 0vh;
  }


  ._lightboxImg_5wij0_1373 {
      /* height: 70vh; */
  }

  ._thumbnail_5wij0_97 {
    width: 95px;
    max-width: 80px;
  } 

  ._slideshowImgMetadata_5wij0_1297 {
    width: 78vw;
  }
}
  

@media screen and (min-width: 80em) {
  ._slideshowInnerContainer_5wij0_249 img {
    /* width: 60vw; */
  }

  ._fullScreenContainer_5wij0_477 img {
    width: 80vw;
  }
}

._lightIcon_5wij0_1423,
._lightIcon_5wij0_1423 svg {
  background-color: white;
  color: black;
}

._lightIcon_5wij0_1423:hover,
._lightIcon_5wij0_1423 svg:hover {
  background-color: white;
  color: black;
  fill: black;
}

._darkIcon_5wij0_1449,
._darkIcon_5wij0_1449 svg {
  background-color: transparent;
  /* background-color: #151515; */
  color: silver;
  fill: silver;
}

._darkIcon_5wij0_1449:hover,
._darkIcon_5wij0_1449 svg:hover {
  color: rgba(107, 107, 107, 0.8);
  fill: rgba(107, 107, 107, 0.8);
}

/* Header icons  */
._lightHeaderIcon_5wij0_1479 svg {
  background-color: white;
  color: black;
  fill: black;
}

._lightHeaderIcon_5wij0_1479 svg:hover {
  background-color: white;
  color: rgb(24, 24, 24, 0.8);
  fill: rgb(24, 24, 24, 0.8);

}

._darkHeaderIcon_5wij0_1505 svg {
  background-color: transparent;
  /* background-color: #151515; */
  color: #626b77;
  fill: #626b77;
}

._darkHeaderIcon_5wij0_1505 svg:hover {
  color: rgba(99, 99, 99, 0.8);
  fill: rgba(99, 99, 99, 0.8);
}

._magnifierImage_5wij0_1529 {
  object-fit: contain;
}

._thumbnails_5wij0_133 ._active_5wij0_1537 {
  border: solid rgb(107, 133, 206) 2px;
}

._inactiveThumbnailBorder_5wij0_1545 {
  border: solid transparent 2px;
}

._thumbnails_5wij0_133 {
  width: 95%;
}

._emblaThumbs_5wij0_1561 {
  --thumbs-slide-spacing: 2px; 
  /* --thumbs-slide-height: 9rem; */
  margin-top: var(--thumbs-slide-spacing);
}

@media screen and (max-width: 40em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */

  ._imgTitleContainer_5wij0_277 {
    /* position: absolute;
    top: 12%; */
  }

  ._slideshowImg_5wij0_233 {
    height: 100vh;
  }
}

@media screen and (max-width: 44em) and (min-width: 30em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */
  ._thumbnailsOuterContainer_5wij0_157 {
    bottom: 11%;
  }

  ._thumbnailsAndCaption_5wij0_221 {
    bottom: 4%;
  }
  
  ._imgTitleContainer_5wij0_277 {
    /* position: absolute;
    top: 5%; */
  }
}

@media screen and (max-width: 46em) and (min-width: 30em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */

  /* .imgTitleContainer {
    position: absolute;
    top: 7%;
  } */
}

@media screen and (max-width: 49em) and (min-width: 45em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */

  /* .imgTitleContainer {
    position: absolute;
    top: 5%;
  } */
}

@media screen and (max-width: 29em) {
  ._fullScreenContainer_5wij0_477 img {
    object-fit: cover;
  }

  ._emblaThumbs_5wij0_1561 {
    --thumbs-slide-spacing: 3px; 
    /* --thumbs-slide-height: 9rem; */
    margin-top: var(--thumbs-slide-spacing);
  }



  ._htmlVideo_5wij0_361 {
    margin-top: 5vh;
  }

  ._thumbnails_5wij0_133 {
    width: 98%;
  }

  ._thumbnail_5wij0_97 {
    width: 80px;
    max-width: 80px;
  }

  ._htmlVideoOuterContainer_5wij0_361 video {
    max-height: 65vh;
  }

  ._videoIconsHeader_5wij0_771 {
    position: fixed;
    top: 2%;
    right: 15px;
  }

  ._videoOuterContainer_5wij0_733 {
    width: 88%;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    max-height: 65vh;
  }

  ._htmlVideoOuterContainer_5wij0_361 {
    width: 94%;
    margin-left: auto;
    margin-right: auto;
  }

  ._iconsHeader_5wij0_49 {
    position: fixed;
    left: 115px;
  }

  ._slideshowInnerVideoContainer_5wij0_567 {
    top: 3%;
  }

  ._next1_5wij0_55,
  ._prev1_5wij0_53 {
    padding-bottom: 2vh;
    padding-top: 2vh;
  }

  ._next1_5wij0_55 {
    padding-left: 4vw;
  }

  ._prev1_5wij0_53 {
    padding-right: 4vw;
  }

  ._iconsHeader_5wij0_49 {
    /* font-size: 28px; */
  }

}

@media screen and (max-width: 53em) {
  ._slideshowImg_5wij0_233 {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100vw;
    height: 70vh;
  }

  ._slideshowImg_5wij0_233 img {
    margin-left: auto;
    margin-right: auto;
  }

  ._slideshowInnerContainerFullScreen_5wij0_1111 {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: top 0.2s ease-in-out 0s;
    top: 10%;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 1000000;
  }

  ._containImg_5wij0_1899 {
    object-fit: contain;
  }
}

._fullScreenContainer_5wij0_477 img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

._thumbnails_5wij0_133 {
  text-align: center;
  white-space: nowrap;
}

._reactTransformComponent_5wij0_1931 {
  margin-left: auto;
  margin-right: auto;
}

._magnifierImage_5wij0_1529 {
  margin-left: auto;
  margin-right: auto;
}

/* CSS loader  */
._loader_5wij0_1953 {
  width: 44px;
  height: 44px;
  box-sizing: border-box;

  border-radius: 50%;

  display: inline-block;
  position: fixed;
  top: 50%;
  left: 50%;
  animation: _rotation_5wij0_1 1s linear infinite;
}

@keyframes _rotation_5wij0_1 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

._dayLoader_5wij0_1999 {
  border: 5px solid #626b77;
  border-bottom-color: transparent;
}

._nightLoader_5wij0_2009 {
  border: 5px solid #fff;
  border-bottom-color: transparent;
}

._lightboxImg_5wij0_1373 {
  max-height: 70vh;
  margin-left: auto;
  margin-right: auto;
}

._controls_5wij0_681 button, ._closeButton_5wij0_2031, ._closeButtonRounded_5wij0_2031 {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
}

._controls_5wij0_681 svg {
  box-sizing: border-box;
}

._closeButton_5wij0_2031 svg, ._closeButtonRounded_5wij0_2031 svg {
  box-sizing: border-box;
  font-size: 16px;
  padding-top: 0.5px;
}

._closeButton_5wij0_2031 {
  padding-top: 3px;
}

._closeButtonRounded_5wij0_2031 {
  cursor: pointer;

}

._closeButtonRounded_5wij0_2031 svg {
  margin: 0;
  padding: 5px;
  background-color: black;
  border-color: transparent;
  border-radius: 28px;

}

._thumbnailsAndCaption_5wij0_221 {
  height: 19vh;
  margin-top: 0em;
  width: 100vw;
}

._thumbnailsWithCaption_5wij0_149 {
  margin-top: 0em;
}

._slideImageAndCaption_5wij0_2123 {
  top: 9%;
}

._slideImageAndCaption_5wij0_2123._hideControlsBar_5wij0_233 {
  top: 0;
}

._slideshowAnimContainer_5wij0_441 {
  -ms-overflow-style: none;
  /* scrollbar-width: none;   */
}
._thumbnails_5wij0_133::-webkit-scrollbar {
  display: none;
}

._roundedBorder_5wij0_2155 {
  border-radius: 20px;
}

._maxWidthFull_5wij0_2163 {
  max-width: 100%;
}

._maxWidthWithoutMagnifier_5wij0_2171 {
  max-width: 80%;
}

@media screen and (max-width: 880px) {
  ._iconsHeader_5wij0_49 {
    position: fixed;
    right: 5%;
  }
}

@media screen and (max-width: 480px) {
  ._iconsHeader_5wij0_49 {
    position: fixed;
    left: 180px;
  }
  
}

@media screen and (max-width: 440px) {
  ._iconsHeader_5wij0_49 {
    position: fixed;
    left: 160px;
  }
}

@media screen and (max-width: 410px) {
  ._iconsHeader_5wij0_49 {
    position: fixed;
    left: 140px;
  }
}

@media screen and (max-width: 385px) {
  ._iconsHeader_5wij0_49 {
    position: fixed;
    left: 135px;
    /* top: 24px; */
  }
}

@media screen and (max-width: 365px) {
  ._iconsHeader_5wij0_49 {
    position: fixed;
    left: 90px;
  }
}

@media screen and (max-width: 345px) {
  ._iconsHeader_5wij0_49 {
    position: fixed;
    left: 82px;
  }
}

@media screen and (max-width: 325px) {
  ._iconsHeader_5wij0_49 {
    position: fixed;
    left: 60px;
  }
}

@media screen and (max-width: 300px) {
  ._iconsHeader_5wij0_49 {
    position: fixed;
    left: 30px;
  }
}

._lightboxVideo_5wij0_2309 {
  margin-left: auto;
  margin-right: auto;
}

._navigation-wrapper_5wij0_2319 {
  position: relative;
}

._dots_5wij0_2327 {
  display: flex;
  padding: 10px 0;
  justify-content: center;
}

._dot_5wij0_2327 {
  border: none;
  width: 10px;
  height: 10px;
  background: #c5c5c5;
  border-radius: 50%;
  margin: 0 5px;
  padding: 5px;
  cursor: pointer;
}

._dot_5wij0_2327:focus {
  outline: none;
}

._dot_5wij0_2327._active_5wij0_1537 {
  background: #000;
}

._arrow_5wij0_2377 {
  position: absolute;
  top: 50%;
  font-size: 24px;
  font-weight: bold;
  transition: all 0.2s;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  color: #fff;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
  font-family: sans-serif;
}

._leftArrow_5wij0_2407 {
  left: 8px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

._rightArrow_5wij0_2421 {
  left: auto;
  right: 8px;
  padding-left: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

._arrow_5wij0_2377:hover {
  color: rgb(230, 230, 230);
}

._arrow--disabled_5wij0_2445,
._arrow--disabled_5wij0_2445:hover {
  color: rgba(255, 255, 255, 0.5);
}

._navDotsMargin_5wij0_2455 {
  margin-top: 12px;
}

._inactiveThumbnailBorderImgSlider_5wij0_2463 {
  border: 'solid transparent 2px';
}

._ytVideoImgSlider_5wij0_2471 {
  width: 100%;
  height: 100%;
}

._ytVideoImgSlider_5wij0_2471 iframe {
  width: 100%;
  height: 100%;
}

._outerYTVideoImgSlider_5wij0_2491 {
  height: 100%;
}

._lightboxjs_5wij0_1 iframe {
  margin: none;
  padding: none;
  border: none;
}

._imgSliderArrow_5wij0_2511 {
  z-index: 100000;
  background-color: transparent;
  border: none;
}

._thumbnails_5wij0_133 {
  margin-left: auto;
  margin-right: auto;
}

._cursorPointer_5wij0_2533 {
  cursor: pointer;
}

._lightboxjsIcon_5wij0_2541 > * { color: inherit; fill: inherit }

._embla_5wij0_1561 {
  margin-left: auto;
  margin-right: auto;
  --slide-spacing: 1rem;
  --slide-size: 100%;
  --slide-height: 19rem;
}

._emblaViewport_5wij0_2561 {
  overflow: hidden;
  width: 100vw;
}

._emblaContainer_5wij0_2571 {
  backface-visibility: hidden; 
  touch-action: pan-y;
  height: auto;
  margin-left: calc(var(--slide-spacing) * -1);
  display: grid;  
  grid-auto-flow: column;  
  grid-auto-columns: 100%; 
  max-width: 100vw;
  margin-left: auto;
  margin-right: auto; 
  /* width: 80%;
*/
}

._emblaContainerImgMetadata_5wij0_2601 {
  width: 78vw;
  max-width: 78vw;
  height: 80vh;
}

._imgdrag_5wij0_2613 ._emblaSlide_5wij0_2613 {
  flex: 0 0 80%;
  min-width: 0;
  max-width: 100%;
  padding-left: 12px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}

._emblaThumbsViewport_5wij0_2633 {
  overflow: hidden;
}

._emblaThumbsContainer_5wij0_2641 {
  display: flex;
  flex-direction: row;
  margin-left: calc(var(--thumbs-slide-spacing) * -1);
  width: 100%;
  /* align-items: center;
  text-align: center;
  width: fit-content; */
  /* justify-content: center; */
  
}

._emblaThumbsContainer_5wij0_2641::before, ._emblaThumbsContainer_5wij0_2641::after {
  content: '';  /* Insert pseudo-element */
  margin: auto; /* Make it push flex items to the center */
}


._emblaThumbsSlide_5wij0_2677 {
  /* min-width: 0; */
  padding-left: var(--thumbs-slide-spacing);
  /* position: relative; */
  /* width: 140px; */
}

._emblaThumbsSlideImg_5wij0_2691 {
  /* display: block; */
  height: var(--thumbs-slide-height);
  width: 100%;
  object-fit: cover;
}

._mlAuto_5wij0_2705 {
  margin-left: auto;
}

._metadata_5wij0_2713 {
  color: white;
}

._emblaSlideGrid_5wij0_2721 {
  display: flex;
}

._metadata_5wij0_2713 {
  text-align: left;
  min-width: 17vw;
  max-width: 17vw;
  padding-top: 5vw;
}

._metadataPanel_5wij0_2743 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

._metadataInnerContainer_5wij0_2755 {
  padding-left: 7vw;
}

._metadataInnerContainer_5wij0_2755 span {
  display: block;
}


._imgMetadataCloseBtn_5wij0_2773 {
  position: absolute;
  top: 1%;
  right: 2%;
  background: none;
  color: white;
  border: none;
  cursor: pointer;
}

/* Styling from react-zoom-pan-pinch library */
._reactTransformWrapper_5wij0_2795 {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  overflow: hidden;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -khtml-user-select: none; /* Konqueror HTML */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  margin: 0;
  padding: 0;
}

._reactTransformComponent_5wij0_1931 {
  display: flex;
  flex-wrap: wrap;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  margin: 0;
  padding: 0;
  transform-origin: 0% 0%;
}

._reactTransformComponent_5wij0_1931 img {
  pointer-events: none;
}

._navigationDot_5wij0_181 {
  height: 10px;
  width: 10px;
  background-color: silver;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

._navigationDotContainer_5wij0_2879 {
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 12px;
  padding-right: 12px;
}

._imgfade_5wij0_2893._emblaContainer_5wij0_2571 {
  transform: none !important; /* override Embla */
  display: flex;
  /* height: 250px; */
}

._notFullScreen_5wij0_2905 {
  top: 0;
}

._imgfade_5wij0_2893._emblaSlide_5wij0_2613 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  position: absolute;
  /* top: 0; */
  left: 0 !important; /* override Embla */
  right: 0 !important; /* override Embla */
  opacity: 0;
  transition: opacity 0.5s;
  counter-increment: embla;
  border-radius: 0.5rem;
}

._imgFadeWithTopCaption_5wij0_2941 {
  top: 16%;
  position: fixed;
}

._imgfade_5wij0_2893._emblaSlideSelected_5wij0_2951 {
  opacity: 1;
  transition: opacity 0.3s;
  z-index: 1;
}

._imgfade_5wij0_2893._emblaSlide_5wij0_2613:before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

._fullImg_5wij0_2977 {
  height: 84vh;
  max-height: 84vh;
  object-fit: contain;
}

._rotateImg90Deg_5wij0_2989{
transform: rotate(90deg);
transition: transform 1s linear;
}  

._rotate_img_5wij0_2999 {
transition: transform 0.7s linear;
}

._fullScreenContainer_5wij0_477 img {
/* max-height: 100vh; */
}

._slideshowImg_5wij0_233 img {
height: 100%;
}

`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"lightboxjs":"_lightboxjs_5wij0_1","slideshowBtn":"_slideshowBtn_5wij0_37","closeIcon":"_closeIcon_5wij0_45","iconsHeader":"_iconsHeader_5wij0_49","prev1":"_prev1_5wij0_53","next1":"_next1_5wij0_55","icon":"_icon_5wij0_49","prevIcon":"_prevIcon_5wij0_69","nextIcon":"_nextIcon_5wij0_71","show":"_show_5wij0_81","displayHidden":"_displayHidden_5wij0_89","thumbnail":"_thumbnail_5wij0_97","thumbnails":"_thumbnails_5wij0_133","thumbnailsWithCaption":"_thumbnailsWithCaption_5wij0_149","thumbnailsOuterContainer":"_thumbnailsOuterContainer_5wij0_157","navigationDots":"_navigationDots_5wij0_181","imageSlide":"_imageSlide_5wij0_197","thumbnailsAndCaption":"_thumbnailsAndCaption_5wij0_221","hideControlsBar":"_hideControlsBar_5wij0_233","slideshowImg":"_slideshowImg_5wij0_233","rotateImgInnerContainer":"_rotateImgInnerContainer_5wij0_241","slideshowInnerContainer":"_slideshowInnerContainer_5wij0_249","videoThumbnailsOuterContainer":"_videoThumbnailsOuterContainer_5wij0_269","imgTitleContainer":"_imgTitleContainer_5wij0_277","thumbnailsOuterContainerMetadata":"_thumbnailsOuterContainerMetadata_5wij0_337","htmlVideoOuterContainer":"_htmlVideoOuterContainer_5wij0_361","caption":"_caption_5wij0_373","galleryImg":"_galleryImg_5wij0_393","modalContainer":"_modalContainer_5wij0_403","slideshowAnimContainer":"_slideshowAnimContainer_5wij0_441","fullScreenContainer":"_fullScreenContainer_5wij0_477","imageInnerContainer":"_imageInnerContainer_5wij0_489","magnifyWrapper":"_magnifyWrapper_5wij0_527","slideshowInnerVideoContainer":"_slideshowInnerVideoContainer_5wij0_567","slideshowInnerContainerThumbnails":"_slideshowInnerContainerThumbnails_5wij0_575","lightboxContainer":"_lightboxContainer_5wij0_599","slideshowAnimImg":"_slideshowAnimImg_5wij0_671","controls":"_controls_5wij0_681","ytVideo":"_ytVideo_5wij0_721","videoOuterContainer":"_videoOuterContainer_5wij0_733","customVideoContainer":"_customVideoContainer_5wij0_761","customEmbedContainer":"_customEmbedContainer_5wij0_761","videoIconsHeader":"_videoIconsHeader_5wij0_771","lightbox":"_lightbox_5wij0_1","imgTitle":"_imgTitle_5wij0_277","innerContainerWithTopCaption":"_innerContainerWithTopCaption_5wij0_1051","slideshowImgFullscreen":"_slideshowImgFullscreen_5wij0_1059","slideshowInnerContainerFullScreen":"_slideshowInnerContainerFullScreen_5wij0_1111","fullScreenLightboxImg":"_fullScreenLightboxImg_5wij0_1119","slideshowInnerContainerImgMetadata":"_slideshowInnerContainerImgMetadata_5wij0_1131","opacityFade":"_opacity-fade_5wij0_1185","imageSliderThumbnails":"_imageSliderThumbnails_5wij0_1221","slideshowImgMetadata":"_slideshowImgMetadata_5wij0_1297","prev1Metadata":"_prev1Metadata_5wij0_1305","slideshowImgWithCaption":"_slideshowImgWithCaption_5wij0_1347","hideControlsBarAndCaption":"_hideControlsBarAndCaption_5wij0_1355","lightboxImg":"_lightboxImg_5wij0_1373","lightIcon":"_lightIcon_5wij0_1423","darkIcon":"_darkIcon_5wij0_1449","lightHeaderIcon":"_lightHeaderIcon_5wij0_1479","darkHeaderIcon":"_darkHeaderIcon_5wij0_1505","magnifierImage":"_magnifierImage_5wij0_1529","active":"_active_5wij0_1537","inactiveThumbnailBorder":"_inactiveThumbnailBorder_5wij0_1545","emblaThumbs":"_emblaThumbs_5wij0_1561","htmlVideo":"_htmlVideo_5wij0_361","containImg":"_containImg_5wij0_1899","reactTransformComponent":"_reactTransformComponent_5wij0_1931","loader":"_loader_5wij0_1953","rotation":"_rotation_5wij0_1","dayLoader":"_dayLoader_5wij0_1999","nightLoader":"_nightLoader_5wij0_2009","closeButton":"_closeButton_5wij0_2031","closeButtonRounded":"_closeButtonRounded_5wij0_2031","slideImageAndCaption":"_slideImageAndCaption_5wij0_2123","roundedBorder":"_roundedBorder_5wij0_2155","maxWidthFull":"_maxWidthFull_5wij0_2163","maxWidthWithoutMagnifier":"_maxWidthWithoutMagnifier_5wij0_2171","lightboxVideo":"_lightboxVideo_5wij0_2309","navigationWrapper":"_navigation-wrapper_5wij0_2319","dots":"_dots_5wij0_2327","dot":"_dot_5wij0_2327","arrow":"_arrow_5wij0_2377","leftArrow":"_leftArrow_5wij0_2407","rightArrow":"_rightArrow_5wij0_2421","arrowDisabled":"_arrow--disabled_5wij0_2445","navDotsMargin":"_navDotsMargin_5wij0_2455","inactiveThumbnailBorderImgSlider":"_inactiveThumbnailBorderImgSlider_5wij0_2463","ytVideoImgSlider":"_ytVideoImgSlider_5wij0_2471","outerYtVideoImgSlider":"_outerYTVideoImgSlider_5wij0_2491","imgSliderArrow":"_imgSliderArrow_5wij0_2511","cursorPointer":"_cursorPointer_5wij0_2533","lightboxjsIcon":"_lightboxjsIcon_5wij0_2541","embla":"_embla_5wij0_1561","emblaViewport":"_emblaViewport_5wij0_2561","emblaContainer":"_emblaContainer_5wij0_2571","emblaContainerImgMetadata":"_emblaContainerImgMetadata_5wij0_2601","imgdrag":"_imgdrag_5wij0_2613","emblaSlide":"_emblaSlide_5wij0_2613","emblaThumbsViewport":"_emblaThumbsViewport_5wij0_2633","emblaThumbsContainer":"_emblaThumbsContainer_5wij0_2641","emblaThumbsSlide":"_emblaThumbsSlide_5wij0_2677","emblaThumbsSlideImg":"_emblaThumbsSlideImg_5wij0_2691","mlAuto":"_mlAuto_5wij0_2705","metadata":"_metadata_5wij0_2713","emblaSlideGrid":"_emblaSlideGrid_5wij0_2721","metadataPanel":"_metadataPanel_5wij0_2743","metadataInnerContainer":"_metadataInnerContainer_5wij0_2755","imgMetadataCloseBtn":"_imgMetadataCloseBtn_5wij0_2773","reactTransformWrapper":"_reactTransformWrapper_5wij0_2795","navigationDot":"_navigationDot_5wij0_181","navigationDotContainer":"_navigationDotContainer_5wij0_2879","imgfade":"_imgfade_5wij0_2893","notFullScreen":"_notFullScreen_5wij0_2905","imgFadeWithTopCaption":"_imgFadeWithTopCaption_5wij0_2941","emblaSlideSelected":"_emblaSlideSelected_5wij0_2951","fullImg":"_fullImg_5wij0_2977","rotateImg90Deg":"_rotateImg90Deg_5wij0_2989","rotateImg":"_rotate_img_5wij0_2999"};
export { css, digest };
  